import { Component, effect, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { HotToastService } from '@ngxpert/hot-toast';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, Inject } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { MemberLoginService } from '../../../services/MemberServices/LoginAndAuth/login.service';
import { AuthStateService } from '../../../services/MemberServices/LoginAndAuth/auth-state.service';

@Component({
  standalone: true,
  selector: 'app-member-navbar',
  templateUrl: './member-navbar.page.html',
  styleUrl: './member-navbar.page.css',
  imports: [CommonModule, RouterLink],
})
export class MemberNavbarPage {
  private router = inject(Router);
  private toast = inject(HotToastService);
  private memberLogin = inject(MemberLoginService);
  private auth = inject(AuthStateService);
  private platformId = inject(PLATFORM_ID) as object;


  readonly isLoggedIn = this.auth.isLoggedIn;
  userName = signal('Member');
  userEmail = signal('');
  theme = signal<'grwlight' | 'grwdark'>('grwlight');
  imageUrl = signal<string | null>(null);





  constructor() {
    if (isPlatformBrowser(this.platformId)) {
      const saved = (localStorage.getItem('__theme') as any) || 'grwlight';
      this.theme.set(saved);
      effect(() => document.documentElement.setAttribute('data-theme', this.theme()));

      // ✅ Replace API call with a reactive subscription to the shared profile
      effect(() => {
        const p = this.auth.profile();
        this.userName.set(p?.representativeName || 'Member');
        this.userEmail.set(p?.companyName || '');
        this.imageUrl.set((p as any)?.profileImageUrl ?? null);
      });

      // If you want a manual refresh button somewhere, call:
      // this.auth.refreshMemberProfileData().subscribe();
    }
  }



  loadProfile() {
    const email = localStorage.getItem('AuthenticatedEmail');
    if (!email) return;
    this.memberLogin.fetchUserDataByEmail(email).subscribe({
      next: (res) => {
        this.userName.set(res.representativeName || 'Member');
        this.userEmail.set(res.emailAddress);
      },
      error: () => {
        this.toast.error('Failed to load user profile');
      },
    });
  }



  logout() {
    // ✅ centralised clear
    this.auth.clearAuth();
    this.toast.success('Logged out successfully');
    this.router.navigate(['/member/login']);
  }

  toggleTheme() {
    const next = this.theme() === 'grwlight' ? 'grwdark' : 'grwlight';
    this.theme.set(next);
    localStorage.setItem('__theme', next);
  }
  navigateTo(section: string) {
    this.router.navigate(['/RequestSection', section]);
  }


}
